<script setup>
import { computed, ref } from 'vue';
import { isEmpty } from 'lodash';
import SelectCifra from '@/components/inputs/SelectCifra.vue';

const props = defineProps({
  centros: { type: Array, required: true },
  agrupacionCentros: { type: Array, required: true },
});

const centroAnadir = ref();
const agrupacionCentrosInternal = ref(props.agrupacionCentros);
const idsSeleccionados = computed(() => (
  agrupacionCentrosInternal.value.map((ac) => ac.centro.id)
));
const centrosDisponibles = computed(() => (
  props.centros.filter((c) => !idsSeleccionados.value.includes(c.id))
));

function addCentro() {
  if (!centroAnadir.value) {
    return;
  }
  agrupacionCentrosInternal.value.push({
    centro_id: centroAnadir.value.id,
    centro: centroAnadir.value,
  });
  centroAnadir.value = null;
}

function delCentro(agrupacionCentro) {
  const index = agrupacionCentrosInternal.value.indexOf(agrupacionCentro);
  agrupacionCentrosInternal.value.splice(index, 1);
}

</script>

<template>
  <div>
    <div class="input-group m-b">
      <SelectCifra
        v-model="centroAnadir"
        :marcador="$t('Seleccione')"
        :opciones="centrosDisponibles"
        :buscable="true"
        :mostrar-etiquetas="false"
        :permitir-vacio="false"
        campo-etiqueta="nombre"
        campo-id="id"
      />
      <div class="btn btn-sm btn-cifra input-group-addon" @click="addCentro">
        <i class="fa fa-plus"></i> {{ $t('Anadir') }}
      </div>
    </div>

    <input
      type="hidden"
      name="json_agrupacion_centros"
      :value="JSON.stringify(agrupacionCentrosInternal)"
    >
    <div v-if="isEmpty(agrupacionCentrosInternal)">
      <div class="alert alert-info text-right">
        {{ $t('pulse_apara_anadir') }} <i class="fa fa-arrow-up m-r-lg"></i>
      </div>
    </div>
    <table v-else class="table table-striped">
      <thead>
        <tr>
          <th>{{ $t('Centro') }}</th>
          <th class="col-min"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(ac, index) in agrupacionCentrosInternal" :key="index">
          <td> {{ ac.centro.nombre }}</td>
          <td>
            <a class="text-danger" @click="delCentro(ac)">
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
